import React, { useState } from 'react';
import { cardsById } from '../../redux/reducers/stackReducer';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
// import { CurrencyDisplay } from '../currencyDisplay';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    // minWidth: 120,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  select: {
    minWidth: '100%'
  },
  selectCard: {
    flex: 3
  },
  selectCount: {
    flex: 1
  },
  container: {
    display: 'flex',
    flexDirection: 'row'
  },
  deleteStackButton: {
    float: 'right',
    width: 24,
    height: 24,
    lineHeight: '24px',
    textAlign: 'center',
    fontWeight: 'bolder',
    color: '#1fb3a4', //'#a0a0a0',
    backgroundColor: '#EFEEEE',
    borderRadius: 12,
    boxShadow:
      '-6px -6px 26px 0px rgba(255,255,255,.83), 6px 6px 16px 0px rgba(217,210,200,.51)'
  }
}));

export default props => {
  const { stackId, onStackChange, onStackRemove } = props;
  const classes = useStyles();

  const [currentCount, setCount] = useState(2);

  //todo get this from what's passed down - only default it in actions
  const [currentCard, setCard] = useState('baseball_cards'); //default to first item..?

  const updateCard = event => {
    setCard(event.target.value);
    onStackChange(stackId, event.target.value, currentCount);
  };

  const updateCount = event => {
    setCount(event.target.value);
    onStackChange(stackId, currentCard, event.target.value);
  };

  //gets all the cards for the select dropdown
  const getCardListByName = () => {
    const cardOptionElements = [];

    for (const cardId in cardsById) {
      if (cardsById.hasOwnProperty(cardId)) {
        cardOptionElements.push([cardId, cardsById[cardId]]);
      }
    }

    cardOptionElements.sort(function(a, b) {
      return a[1].value - b[1].value;
    });

    return cardOptionElements.map(cardItem => (
      <MenuItem key={cardItem[0]} value={cardItem[0]}>
        {cardItem[1].name}
        {/* {cardItem[1].name + ' - '} <CurrencyDisplay value={cardItem[1].value} /> */}
      </MenuItem>
    ));
  };

  const getCountOptions = () => {
    const max = cardsById[currentCard].count;
    const min = 1;
    const countArray = [];

    for (let i = min; i <= max; i++) {
      countArray.push(i);
    }

    return countArray.map(count => (
      <MenuItem key={count} value={count}>
        {count}
      </MenuItem>
    ));
  };

  const handleRemoveStack = () => {
    onStackRemove(stackId);
  };

  return (
    <React.Fragment>
      <div className={classes.deleteStackButton} onClick={handleRemoveStack}>
        X
      </div>

      <div className={classes.container}>
        <FormControl className={classes.formControl + ' ' + classes.selectCard}>
          <InputLabel id="card-label">Card</InputLabel>
          <Select
            className={classes.select}
            id="card-label"
            value={currentCard}
            onChange={updateCard}
          >
            {getCardListByName()}
          </Select>
        </FormControl>

        <FormControl
          className={classes.formControl + ' ' + classes.selectCount}
        >
          <InputLabel id="card-count-label">Count</InputLabel>
          <Select
            className={classes.select}
            id="card-count-label"
            value={currentCount}
            onChange={updateCount}
          >
            {getCountOptions()}
          </Select>
        </FormControl>
      </div>
    </React.Fragment>
  );
};
